import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { background_onboarding, logo } from '../../constants/icons';

const PlayerMandateKycVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { token: paramToken } = useParams();
  const {
    documentUrl,
    mobile,
    playerId,
    token: stateToken,
    verification,
    inviteParams,
    rawQuery,
    email,
    inviteSentBy,
    senderType,
    agencyId,
    type,
  } = location.state || {};

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const queryToken = searchParams.get('invite_token');
  const mandateToken = stateToken || paramToken || queryToken || null;

  const basePath = mandateToken
    ? `/player-register-mandate/${mandateToken}`
    : '/player-register-mandate';

  const sharedState = useMemo(
    () => ({
      mobile,
      playerId,
      token: mandateToken,
      verification,
      inviteParams,
      rawQuery,
      email,
      inviteSentBy,
      senderType,
      agencyId,
      type,
    }),
    [
      mandateToken,
      mobile,
      playerId,
      verification,
      inviteParams,
      rawQuery,
      email,
      inviteSentBy,
      senderType,
      agencyId,
      type,
    ]
  );

  const goToSuccess = searchParams.get("gotosuccess") === "yes";
  const goToRejection = searchParams.get("gotorejection") === "yes";

  useEffect(() => {
    if (goToSuccess) {
      navigate(`${basePath}/action`, {
        replace: true,
        state: sharedState,
      });
    } else if (goToRejection) {
      navigate(`${basePath}/rejected`, {
        replace: true,
        state: sharedState,
      });
    }
  }, [goToSuccess, goToRejection, basePath, navigate, sharedState]);

  if (!documentUrl) {
    return (
      <div className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
        style={{
          backgroundImage: `url(${background_onboarding})`,
        }}
      >
        <div className="bg-white p-8 w-full max-w-[544px] flex flex-col rounded-xl gap-4 items-center text-center">
          <img src={logo} alt="Transfer Pitch" className="h-10 mb-2 mx-auto" />
          <div className="text-[#1A212F] text-2xl font-bold">Error</div>
          <div className="text-[#1A212F] text-base">Invalid verification link. Please try again.</div>
          <button
            type="button"
            onClick={() => {
              navigate(`${basePath}/verify`, {
                state: sharedState,
              });
            }}
            className="mt-2 w-full h-[44px] rounded-lg bg-[#2283FF] text-white text-[14px] font-medium"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${background_onboarding})`,
      }}
    >
      <div className="bg-white p-6 w-full max-w-[544px] flex flex-col rounded-xl gap-6">
        <img src={logo} alt="Transfer Pitch" className="h-10 mb-2 mx-auto" />
        <div className="text-center mb-4">
          <h2 className="text-xl font-semibold text-[#1A212F] mb-2">Identity Verification</h2>
          <p className="text-sm text-gray-600">Please complete the verification process below</p>
        </div>
        
        <iframe
          src={documentUrl}
          className="flex w-full h-[600px] rounded-lg border"
          title="KYC Verification"
        />
        
        <div className="text-center">
          <p className="text-xs text-gray-500">
            Having trouble? The verification will automatically proceed once completed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlayerMandateKycVerification;